
const state = {
  user: {},
  courseList: [],
  activityList: [],
  activityCourseList: [],
  schoolList: [],
  coachList: [],
  uploadCoachList: [],
  orderList: [],
  stockList: [],
  studentList: [],
  certList: [],
  course: {},
  activity: {},
  school: {},
  coach: {},
  cert: {},
};

export default state;